import React from "react";

import { useTranslation } from "react-i18next";

import useFontFaceGroupLabel from "@/src/hooks/useFontFaceGroupLabel";
import { groupFaceListByDescriptor } from "@/src/utils/fontFaces";

import type { JSX } from "react";

import type { FontFamily } from "@/src/api/StylesAPI.types";

interface UploadedFontSummaryProps {
  family: FontFamily;
}

function UploadedFontSummary({
  family,
}: UploadedFontSummaryProps): JSX.Element {
  const { t } = useTranslation("editor-appearance");
  const buildGroupLabel = useFontFaceGroupLabel();

  return (
    <div className="flex flex-col gap-2">
      <span className="font-semibold">{family.display_name}</span>
      <span className="text-muted-foreground text-sm">
        {t("detectedFaces")}
      </span>
      {groupFaceListByDescriptor(family.faces).map((group) => (
        <span key={`${group.weight}-${group.style}`} className="text-sm">
          {`${buildGroupLabel(group)} · ${group.faceList
            .map((face) => face.format)
            .join(", ")}`}
        </span>
      ))}
    </div>
  );
}

export default UploadedFontSummary;
